module.exports = ".mainMsg {\n  display: inherit;\n  color: #939393;\n  font-size: 20px;\n  text-align: center; }\n  .mainMsg.text {\n    font-size: 16px;\n    width: 810px;\n    margin: 0 auto; }\n  #mainImage {\n  margin: 0 auto;\n  text-align: center;\n  margin-top: 50px;\n  margin-bottom: 20px; }\n  .number {\n  display: inherit;\n  letter-spacing: 0px;\n  color: #ea524b;\n  font-size: 24px;\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/no-smart-meter/no-smart-meter.component.scss
// module id = ./src/app/shared/components/no-smart-meter/no-smart-meter.component.scss
// module chunks = main